import { observable, action, computed, decorate } from 'mobx'
import {
  The,
  notify,
  setErrorsOnFormAndNotifyGeneralErrors,
} from '../helpers/generalHelpers'
import {
  getUserProfile,
  requestPhoneNumberConfirmation,
  requestEmailConfirmation,
  services,
} from '../api/api'
import { newUserPlans } from '../UserPlans/userPlans'
import { FormattedMessage } from 'react-intl'
import { Logger } from '../services/logger'
import { validateResponse } from 'helpers/generalHelpers'

class profileStore {
  isLoading = false

  isLoadingVerificationStatus = false

  hasRequestedVerification = false

  profile = {
    username: '',
    email: '',
    weekly_digest: null,
  }

  setRequestedConfirmation(newValue) {
    this.hasRequestedVerification = newValue
  }

  setProfileInfo = (newProfileData) => {
    Logger.setUser(newProfileData)
    this.profile = newProfileData
  }

  setIsLoading = (bool) => {
    this.isLoading = bool
  }

  setIsLoadingVerification = (bool) => {
    this.isLoadingVerificationStatus = bool
  }

  setPhoneVerificationStatus(newValue) {
    this.profile.verified_phone = newValue
  }

  setEmailVerificationStatus(newValue) {
    this.profile.verified_email = newValue
  }

  get isOnPaidPlan() {
    try {
      return [
        newUserPlans.PRO,
        newUserPlans.TEAM,
        newUserPlans.ENTERPRISE,
        newUserPlans.ON_PREMISE,
      ].includes(this.profile.plan.slug)
    } catch (error) {
      return false
    }
  }

  get isPlanUpgradeAble() {
    try {
      return this.profile.plan.slug !== newUserPlans.ON_PREMISE
    } catch (error) {
      return false
    }
  }
}
decorate(profileStore, {
  isLoading: observable,
  isLoadingVerificationStatus: observable,
  hasRequestedVerification: observable,
  profile: observable,
  setRequestedConfirmation: action.bound,
  setProfileInfo: action.bound,
  setIsLoading: action.bound,
  setIsLoadingVerification: action.bound,
  setPhoneVerificationStatus: action.bound,
  setEmailVerificationStatus: action.bound,
  isPlanUpgradeAble: computed,
  isOnPaidPlan: computed,
})

const ProfileStore = new profileStore()
export default ProfileStore

export const initializeTheProfileData = async () => {
  try {
    const profileRequests = Promise.all([
      getUserProfile(),
      services.auth.getProfileData(),
    ])
    const userCompleteProfile = await profileRequests
    const [formalooProfile, icasProfile] =
      userCompleteProfile.map(validateResponse)
    if (formalooProfile.error || icasProfile.error) {
      const errors = {
        ...formalooProfile.error,
        ...icasProfile.error,
      }
      return Promise.reject(errors)
    }
    ProfileStore.setProfileInfo({
      ...formalooProfile.profile,
      ...icasProfile.profile,
    })
    return Promise.resolve({
      ...formalooProfile.profile,
      ...icasProfile.profile,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function fetchUserProfile() {
  ProfileStore.setIsLoading(true)
  initializeTheProfileData()
    .then((res) => {
      ProfileStore.setIsLoading(false)
      return Promise.resolve(res)
    })
    .catch((error) => {
      setErrorsOnFormAndNotifyGeneralErrors(error)
      ProfileStore.setIsLoading(false)
      return Promise.reject(error)
    })
}

export async function requestPhoneNumberVerificationUpdate() {
  ProfileStore.setIsLoadingVerification(true)
  ProfileStore.setRequestedConfirmation(true)

  const [err, res] = await The(requestPhoneNumberConfirmation())

  if (err) {
    ProfileStore.setIsLoadingVerification(false)
    notify(err.general_errors, 'error')
  }

  if (res) {
    notify(
      <FormattedMessage id="general.dashboard.warningMessage.verificationRequestSuccess" />,
      'success'
    )

    ProfileStore.setIsLoadingVerification(false)
    return res.profile
  }

  ProfileStore.setIsLoadingVerification(false)
  return null
}

export async function requestEmailVerificationUpdate() {
  ProfileStore.setIsLoadingVerification(true)
  ProfileStore.setRequestedConfirmation(true)

  const [err, res] = await The(requestEmailConfirmation())

  if (err) {
    ProfileStore.setIsLoadingVerification(false)
    notify(err.general_errors, 'error')
  }

  if (res) {
    notify(
      <FormattedMessage id="general.dashboard.warningMessage.verificationRequestSuccess" />,
      'success'
    )

    ProfileStore.setIsLoadingVerification(false)
    return res.profile
  }

  ProfileStore.setIsLoadingVerification(false)
  return null
}
